import styles from './AvatarIcon.module.scss';
import { useEffect, useState } from 'react';
import clx from 'classnames';

const AvatarIcon = ({ icon, name, size, lazy = false }) => {
  const substringName = (name) => {
    if (!name) return '';
    const matches = name.match(/\b(\w)/g);
    return matches?.join('').toUpperCase();
  };
  const colors = [
    '#05DCA9',
    '#FF93C7',
    '#FFA16C',
    '#A5C',
    '#4AA0D1',
    '#C4C4C4',
    '#FF6868',
    '#8DCDF0',
    '#1f1f1f',
  ];
  const initials = substringName(name);
  const [first, second] = [initials?.charCodeAt(0) || 0, initials?.charCodeAt(1) || 0];
  const color = colors[(first + second) % colors.length];

  const [isError, setError] = useState(false);

  useEffect(() => {
    setError(false);
  }, [icon]);

  return (
    <div
      className={clx(styles.icon_container, { [styles.is_error]: isError || !icon })}
      style={{
        width: size,
        height: size,
        minWidth: size,
      }}
    >
      {!!icon && (
        <img
          key={icon}
          className={styles.icon_image}
          src={icon}
          alt=""
          loading={lazy ? 'lazy' : undefined}
          decoding="async"
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            setError(true);
          }}
          onLoad={() => setError(false)}
        />
      )}
      <div
        className={styles.icon_on_error}
        style={{
          backgroundColor: color,
        }}
      >
        <div className={styles.text}>{initials}</div>
      </div>
    </div>
  );
};

export default AvatarIcon;
